import { Button, Typography } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { BaseDialog } from '@/components/shared/base-dialog';
import { Icon } from '@/components/shared/icon';
import { useNotification } from '@/context/notification';
import { clientKeys } from '@/data/@clients/client-keys';
import { PlanStatus } from '@/data/idp/plans/interfaces';
import { usePlanStatuses } from '@/data/idp/plans/statuses';

interface StartPlanDialogProps {
  onClose: () => void;
  id: string;
}

export const StartPlanDialog = ({ onClose, id }: StartPlanDialogProps) => {
  const queryClient = useQueryClient();
  const { mutate, isPending } = usePlanStatuses();
  const { toast } = useNotification();

  const handleStartPlan = () => {
    mutate(
      { id, status: PlanStatus.InProgress },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: [clientKeys.usePlanShow] });
          queryClient.invalidateQueries({
            queryKey: [clientKeys.usePlansIndex],
          });
          toast({
            content: 'Plano iniciado com sucesso!',
            type: 'success',
          });
          onClose();
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onError: (error: any) => {
          if (error.response.status !== 422) {
            toast({
              content:
                'Ocorreu um erro ao iniciar o plano. Tente novamente mais tarde',
              type: 'error',
            });
            return;
          }
          const offenderPlan =
            error.response?.data?.errors?.offender_plan?.title ??
            'que está em andamento';
          toast({
            content: `Só é possível ter um plano em andamento por vez. Para iniciar esse, finalize o plano ${offenderPlan}.`,
            type: 'error',
          });
        },
      }
    );
  };

  return (
    <BaseDialog
      title="Iniciar plano de desenvolvimento"
      onClose={onClose}
      icon={<Icon name="siren-rounded" />}
      actionsComponent={
        <>
          <Button onClick={onClose}>Voltar</Button>
          <Button
            variant="contained"
            onClick={handleStartPlan}
            loading={isPending}
          >
            Iniciar o plano
          </Button>
        </>
      }
    >
      <Typography>
        Depois de iniciado, você vai poder acompanhar e atualizar o progresso
        das atividades. E não se preocupe, mesmo depois de inicado é possível
        editá-lo à vontade.
      </Typography>
    </BaseDialog>
  );
};
